<template>
  <div class="multiple-upload-draggable">
    <div class="uploaded-list" v-if="filelist.length">
      <draggable
        v-model="filelist"
        draggable=".uploaded-item"
        handle=".el-icon-rank"
        v-bind="dragOptions"
      >
        <div
          class="uploaded-item"
          :style="uploadItemStyles"
          v-for="(item, index) in filelist"
          :key="index"
        >
          <div class="cover">
            <i class="el-icon el-icon-delete" @click="handleDel(index)"></i>
            <i class="el-icon el-icon-view" @click="handlePreview(index)"></i>
            <i class="el-icon el-icon-rank"></i>
          </div>

          <el-image
            :src="item"
            ref="_imageRef"
            class="image"
            fit="cover"
            :preview-src-list="filelist"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
      </draggable>
    </div>
    <el-upload
      ref="uploadRef"
      v-if="filelist.length < uploadMaxLen"
      class="image-uploader"
      :style="uploadItemStyles"
      :name="name"
      :action="uploadUrl"
      :headers="headers"
      :show-file-list="false"
      :data="{ token: token }"
      :multiple="true"
      :limit="uploadMaxLen - filelist.length"
      :on-success="handleSuccess"
      :on-exceed="handleExceed"
      :before-upload="beforeUpload"
    >
      <i class="el-icon-plus image-uploader-icon"></i>
      <!-- <div slot="tip" class="el-upload__tip">文件大小限制：10MB</div> -->
    </el-upload>

    <!-- 预览图 -->
    <el-image
      class="previewImage"
      ref="previewImageRef"
      :src="filelist[0]"
      :initial-index="initialPreviewIndex"
      :preview-src-list="filelist"
    >
    </el-image>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { cloneDeep } from "lodash";
export default {
  props: {
    uploadedList: {
      type: Array,
      default: () => [],
    },
    uploadMaxLen: {
      type: Number,
      default: 8,
    },
    name: {
      type: String,
      default: "pic",
    },
    uploadItemStyles: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      filelist: [],
      initialPreviewIndex: 0,
      token: sessionStorage.getItem("token"),
    };
  },
  computed: {
    uploadUrl() {
      return `https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic`;
    },
    headers() {
      return {
        // Authorization: storage.get(ACCESS_TOKEN)
      };
    },
    dragOptions() {
      return {
        animation: 300,
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  methods: {
    handleDel(index) {
      this.$confirm("删除当前图片, 是否继续?", "温馨提醒", {
        confirmButtonText: "确定删除",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.filelist.splice(index, 1);
      });
    },
    handlePreview(index) {
      // console.log("_handlePreview", index);
      this.initialPreviewIndex = index;
      this.$refs["previewImageRef"].showViewer = true;
    },
    handleSuccess(res) {
      const { result, pic_url } = res;
      if (result === 1) {
        this.filelist.push(pic_url);
      }
    },
    handleExceed() {
      this.$message.warning(
        `限制最大上传${this.uploadMaxLen}张, 当前已有${this.filelist.length}张!`
      );
      // TODO: 超限最大上传制时调用一次清除已上传列表
      this.$refs.uploadRef.clearFiles();
    },
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 20;
      if (!isLt1M) {
        this.$message.error("上传图片大小不能超过 20MB!");
      }
      return isLt1M;
    },
  },
  watch: {
    uploadedList: {
      handler(newV, oldV) {
        this.filelist = newV;
      },
      immediate: true,
    },
    filelist: {
      handler(newV, oldV) {
        // console.log("_filelist watch", newV)
        this.$emit("update:uploadedList", newV);
      },
      immediate: true,
    },
  },
  mounted() {
    //  清空已上传文件列表
    // this.$refs.uploadRef.clearFiles()
  },
  components: {
    draggable,
  },
};
</script>

<style lang="less" scoped>
.multiple-upload-draggable {
  position: relative;
  // padding-bottom: 24px;
  padding-bottom: 12px;
  min-height: 60px;
  display: flex;
  .uploaded-list {
    & > div {
      display: flex;
      flex-wrap: wrap;
      .uploaded-item {
        width: 110px;
        height: 110px;
        position: relative;
        border: 1px dotted #c2c8d1;
        border-radius: 6px;
        box-sizing: border-box;
        overflow: hidden;
        margin-right: 12px;
        margin-bottom: 12px;
        .image {
          width: 100%;
          height: 100%;
        }
        &:hover {
          & > .cover {
            display: block;
          }
        }
        .cover {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 99;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.6);
          border-radius: 6px;
          display: none;
          .el-icon {
            position: absolute;
            display: inline-block;
            padding: 12px;
            font-size: 24px;
            color: #fff;
            cursor: pointer;
            &.el-icon-delete {
              right: 0;
              top: 0;
            }
            &.el-icon-view {
              left: 0;
              top: 0;
            }
            &.el-icon-rank {
              bottom: 0;
              right: 0;
              cursor: move;
            }
          }
        }
      }
    }
  }
  .image-uploader {
    width: 110px;
    height: 110px;
    border: 1px solid #c2c8d1;
    & /deep/ .el-upload {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .el-upload__tip {
      position: absolute;
      width: 100%;
      left: 12px;
      bottom: 0;
    }
  }
}

.previewImage {
  position: fixed;
  opacity: 0;
  right: 9999px;
  top: 9999px;
}
</style>
